import { render } from "./BerichtMeKuErhebungsbogen.pug?vue&type=template&id=56f601a8&lang=pug"
import script from "./BerichtMeKuErhebungsbogen.js?vue&type=script&lang=js"
export * from "./BerichtMeKuErhebungsbogen.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__